<script>
export default {
    name: "TBScreeningReport",

    data() {

        return {
            patients: [],
            tbsreeningdata: [],
            presumptivetbsreeningdata: [],
            nonpresumptivetbsreeningdata: [],
            filter: {
                dateFrom: window.moment().format(`YYYY-MM-DD`),
                dateTo: window.moment().format(`YYYY-MM-DD`),
                search: ``,
                ward: ``,
            }
        };
    },
    computed: {
        Presumptive () {

        if(!this.tbsreeningdata.length) return 0;
        
        return this.tbsreeningdata.filter(g=>g.remarks=="Presumptive").length;
      },

      NonPresumptive () {

if(!this.tbsreeningdata.length) return 0;

return this.tbsreeningdata.filter(g=>g.remarks=="NoN Presumptive").length;
},

       
    },
    mounted() {

        Promise.allSettled([ this.fetchTbScreeningDateFilter(), ]).then(() => {}).catch(() => {});
    },

    methods: {

        fetchTbScreeningDateFilter() {
            if(!this.filter.dateFrom || !this.filter.dateTo) return Promise.reject();

            let url = `PatientReports/GetTBScreenings?Datefrom=${this.filter.dateFrom}&Dateto=${this.filter.dateTo}`;
            url += this.filter.search? `&SearchText=${this.filter.search}`:``;
            this.$root.loading = true;
            return this.$http.get(url)
                .then(response => {
                    this.tbsreeningdata = response.data;
                    this.$root.loading = false;
            }).catch(() => { this.$root.loading = false; });
        },

        fetchTbScreeningSearch() {
            if(!this.filter.search) return this.fetchTbScreeningDateFilter();

            this.$root.loading = true;
            return this.$http.get(`PatientReports/GetPatientTBScreeningSearch?SearchText=${this.filter.search}`)
                .then(response => {
                    this.tbsreeningdata = response.data;
                    this.$root.loading = false;
            }).catch(() => { this.$root.loading = false; });
        },

        printGatePassReport() {

            window.open(`/reports/patients/gate-pass-report/print?dateFrom=${this.filter.dateFrom}&dateTo=${this.filter.dateTo}`, '_blank', `ReportPrint`, "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes");
        },

        printGatePass(patient) {
            window.open(`/admissions/gate-pass/${patient.patientID}/${patient.dateAdmitted}`, 
                '_blank', 
                `GatePassPrint`, 
                "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes");
        },
    },
}
</script>
<template>
<tail-base-layout>
  <template v-slot:breadcrum>
      <div class="bg-blue-800 p-tiny text-xs text-white rounded">
         <nav class="bg-grey-light rounded font-sans w-full p-tiny">
           <ol class="list-reset flex text-grey-dark">
             <li><router-link :to="{name : 'reports.patients'}">Patient Reports</router-link></li>
             <li><span class="mx-2">/</span></li>
             <li>TB Screening Report</li>
           </ol>
         </nav>
      </div>
  </template>
  <template v-slot:content>
      <tail-card>
        <template v-slot:card-header>
            <h5 class="font-bold text-sm">TB Screening Report</h5>
        </template>
        <template v-slot:card-body>
          <div class="flex flex-wrap">
              <div class="md:w-1/5 sm:w-full p-tiny">
                  <label for="grid-search" class="label-control">Search:</label>
                  <input type="text" id="grid-search" 
                    v-model.trim="filter.search" 
                    @keydown.enter="fetchTbScreeningSearch" 
                    placeholder="Press enter to search" 
                    class="input-control input-sm text-xs">
              </div>
              <div class="md:w-1/5 sm:w-full p-tiny">
                  <label for="grid-date-from" class="label-control">From:</label>
                  <input type="date" v-model.trim="filter.dateFrom" 
                    id="grid-date-from" class="input-control input-sm text-xs">
              </div>
              <div class="md:w-1/5 sm:w-full p-tiny">
                  <label for="grid-date-to" class="label-control">To:</label>
                  <input type="date" v-model.trim="filter.dateTo" 
                    id="grid-date-to" class="input-control input-sm text-xs">
              </div>
              <div class="md:w-1/12 sm:w-full p-tiny mt-4">
                  <button class="btn-sm btn-info text-xs rounded" 
                    @click.prevent="fetchTbScreeningDateFilter">
                        <i class="fa fa-filter"></i> Filter</button>
              </div>
              <div class="md:w-1/12 sm:w-full p-tiny mt-4">
                  <button class="btn-sm btn-primary text-xs rounded" 
                    @click.prevent="$root.exportToExcel(`gate-pass-report`, `gatePassReport`)">
                        <i class="fa fa-file-excel"></i> Export</button>
              </div>
              <div class="md:w-1/12 sm:w-full p-tiny mt-4">
                  <button 
                    class="btn-sm btn-info text-xs rounded"
                    @click.prevent="printGatePassReport">
                        <i class="fa fa-print"></i> Print</button>
              </div>
          </div>
          <div class="w-full overflow-auto">
              <table class="table table-hover" id="gatePassReport">
                  <thead class="bg-blue-500 text-xs text-white">
                        <tr class="w-full flex">
                            <th class="p-tiny flex-1">Date</th>
                            <th class="p-tiny w-1/6">Patient</th>
                            <th class="p-tiny flex-1">OPFile No</th>
                            <th class="p-tiny flex-1">IPFile No</th>
                            <th class="p-tiny flex-1">Gender</th>
                            <th class="p-tiny flex-1">Age</th>
                            <th class="p-tiny flex-1">Cough of any Duration</th>
                            <th class="p-tiny flex-1">Fever</th>
                            <th class="p-tiny flex-1">Night Sweats</th>
                            <th class="p-tiny flex-1">Weight Loss</th> 
                            <th class="p-tiny flex-1">Chest Pain</th>  
                            <th class="p-tiny flex-1">History of Contact With TB</th>  
                            <th class="p-tiny flex-1">Reduced Play Fullness(children)</th> 
                            <th class="p-tiny flex-1">Remarks</th> 
                        </tr>
                  </thead>
                  <tfoot>
                      <tr class="w-full flex">
                          <td class="w-1/2 p-tiny"></td>
                          <td class="w-1/2 p-tiny text-right">Total Patients: {{ tbsreeningdata.length }}</td>
                          <td class="w-1/2 p-tiny text-right">Total Patients Presumptive: {{ Presumptive }}</td>
                          <td class="w-1/2 p-tiny text-right">Total Patients NoN Presumptive: {{ NonPresumptive }}</td>
                      </tr>
                  </tfoot>
                  <tbody class="text-xs bg-gray-100 flex flex-col items-center overflow-auto" style="height:65vh;">
                      <tr class="w-full flex" v-for="(tbsreening, idx) in tbsreeningdata" :key="idx">
                        <td class="p-tiny flex-1">{{ tbsreening.date | dateFormat }}</td>
                            <td class="p-tiny w-1/6">{{ tbsreening.names }}</td>
                          <td class="p-tiny flex-1">{{ tbsreening.opfileno }}</td>
                          <td class="p-tiny flex-1">{{ tbsreening.ipfileno }}</td>
                          <td class="p-tiny flex-1">{{ tbsreening.gender }}</td>
                          <td class="p-tiny flex-1">{{ tbsreening.age }} yrs</td>
                          <td class="p-tiny flex-1">{{ tbsreening.coughofanyDuration}}</td>
                          <td class="p-tiny flex-1">{{ tbsreening.fever }}</td>
                          <td class="p-tiny flex-1">{{ tbsreening.nightSweats }}</td>
                          <td class="p-tiny flex-1">{{ tbsreening.weightLoss }}</td> 
                          <td class="p-tiny flex-1">{{ tbsreening.chestPain }}</td> 
                          <td class="p-tiny flex-1">{{ tbsreening.historyofContactWithTB }}</td> 
                          <td class="p-tiny flex-1">{{ tbsreening.reducedPlayFullness }}</td>  
                          <td class="p-tiny flex-1">{{ tbsreening.remarks }}</td>  
                         
                      </tr>
                  </tbody>
              </table>
          </div>
        </template>
      </tail-card>
  </template>
</tail-base-layout>
</template>